<template>
  <div id="app">
    <!-- 主题颜色切换 -->
    <!-- <b-dropdown :text="$t('common.themeChoice')" class="m-2 max">
			<b-dropdown-item v-for="item in options" :key="item.value" @click="selectOption(item.value)">
				{{ item.text }}
			</b-dropdown-item>
		</b-dropdown> -->
    <!-- 语言切换 -->

    <!-- <b-dropdown class="m-2 max" :text="$i18n.locale == 'en' ? 'EN' : $i18n.locale == 'cht' ? '繁体' : 'CN'">

      <b-dropdown-item @click="changeLang('en')" :class="$i18n.locale == 'en' ? 'active' : ''">EN</b-dropdown-item>
      <b-dropdown-item @click="changeLang('cn')" :class="$i18n.locale == 'cn' ? 'active' : ''">CN</b-dropdown-item>
      <b-dropdown-item @click="changeLang('cht')" :class="$i18n.locale == 'cht' ? 'active' : ''">繁体</b-dropdown-item>

    </b-dropdown> -->

    <!-- 骨架屏  -->
    <skeleton-screen v-show="!dataLoaded"></skeleton-screen>
    <div
      v-show="dataLoaded"
      class="col-md-12 baise sjioashd"
      style="height: 100%"
    >
      <div
        class="pr-3"
        style="position: fixed; width: 100%; z-index: 999; background: #ffffff"
      >
        <top :coin="coin" :user="user"></top>
      </div>
      <top style="visibility: hidden" :coin="coin" :user="user"></top>
      <!-- 手机端左侧显示 -->
      <div class="sjiindex" style="height: 66px">
        <nav
          id="sidebarMenu"
          style="
            z-index: 99999;
            width: 36%;
            height: 100vh;
            position: relative;
            overflow: auto;
          "
          class="bg-light sidebar position-fixed collapse pl-3 sjleft"
        >
          <left :user="user" @toggleMenu="yiny"></left>
        </nav>
        <!-- 小屏幕的导航栏 -->
        <!-- special-activity -->
        <div
          style="
            position: fixed;
            width: 100%;
            z-index: 999;
            background: #ffffff;
            height: 66px;
          "
          v-if="route.includes('special-activity') ? false : true"
          class="xptop"
        >
          <div style="display: flex; align-items: center">
            <img
              class="ml-2"
              @click="toggleMenu"
              v-show="!beih"
              style="
                width: calc(25px + 0.4vw);
                height: calc(25px + 0.4vw);
                margin-right: 2vw;
              "
              src="@/img/icon_xf@2x.png"
              alt=""
            />
            <img
              class="ml-2"
              @click="toggleMenu"
              v-show="beih"
              style="width: calc(25px + 0.4vw); height: calc(25px + 0.4vw)"
              src=""
              alt=""
            />
            <img
              class="mr-2"
              style="width: 40px; margin: 0 2vw 0 3vw"
              src="@/img/daohangl/pic_hssy_logo@2x.png"
              alt=""
              @click="indexPath"
            />
            <div
              style="font-size: calc(11px + 0.3vw); font-weight: 500"
              @click="indexPath"
            >
              {{ $t("好事道") }}
            </div>
          </div>
          <div class="d-flex pt-3 pb-3 align-items-center">
            <div
              @click="funs()"
              class="d-flex align-items-center curpo ckqbb p-2 pl-3 mr-2"
              style="background: #ffebd2; border-radius: 12px"
            >
              <!-- <img class="mr-1" style="width: 28px;font-size: calc(9px + 0.4vw);font-weight: 500;" src="@/img/daohangl/pic_hssy_haorenbi@2x.png" alt="" /> -->
              <div class="">
                <!-- <div style="font-size: calc(8px + 0.4vw);">{{ $t('总发行好人币') }}</div> -->
                <div class="sjbxzt" style="font-size: calc(8px + 0.4vw)">
                  {{ $t("总发好人积分") }}
                </div>
                <div
                  class="sjbzt"
                  style="font-size: calc(8px + 0.4vw); font-weight: 700"
                >
                  {{
                    coin.good_coin
                      ? coin.good_coin
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0"
                  }}
                </div>
              </div>
            </div>
            <div
              @click="funs()"
              class="d-flex align-items-center p-2 pl-3 mr-2 curpo ckqbb"
              style="background: #fdddc9; border-radius: 12px"
            >
              <!-- <img class="mr-1" style="width: 28px;font-size: calc(9px + 0.4vw);font-weight: 500;" src="@/img/daohangl/pic_hssy_tanbi@2x.png" alt="" /> -->
              <div class="">
                <!-- <div style="font-size: calc(8px + 0.4vw);">{{ $t('总发行碳币') }}</div> -->
                <div class="sjbxzt" style="font-size: calc(8px + 0.4vw)">
                  {{ $t("总发碳积分") }}
                </div>

                <div
                  class="sjbzt"
                  style="font-size: calc(8px + 0.4vw); font-weight: 700"
                >
                  {{
                    coin.carbon_coin
                      ? coin.carbon_coin
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0"
                  }}
                </div>
              </div>
            </div>
            <!-- <div class="d-flex curpo mr-3 mixsz align-items-center" v-if="token" @click="nonetoken()">
              <img style="width: 28px;height: 28px;" class="mr-1" src="@/img/daohangl/icon_tcdl@2x.png" alt="" />
              <div class="" style="font-size: calc(9px + 0.4vw);">{{ $t('退出登录') }}</div>
            </div>
            <div class="dengluann pt-2 pb-2 mr-3 pl-3 pr-3" v-else @click="nonetoken()">
              <div class="" style="font-size: calc(9px + 0.4vw);">{{ $t('common.login') }}</div>
            </div> -->
          </div>
          <div
            v-show="beih"
            @click="yiny"
            style="
              width: 100%;
              height: 100%;
              background: #000;
              z-index: 999;
              position: absolute;
              opacity: 0.2;
            "
          ></div>
        </div>
        <div
          style="visibility: hidden"
          v-if="route.includes('special-activity') ? false : true"
          class="xptop"
        >
          <img
            class="ml-2"
            @click="toggleMenu"
            v-show="!beih"
            style="width: calc(28px + 0.4vw); height: calc(28px + 0.4vw)"
            src="@/img/icon_xf@2x.png"
            alt=""
          />
          <img
            class="ml-2"
            @click="toggleMenu"
            v-show="beih"
            style="width: calc(28px + 0.4vw); height: calc(28px + 0.4vw)"
            src=""
            alt=""
          />
          <div class="d-flex pt-3 pb-3 align-items-center">
            <div
              @click="funs()"
              class="d-flex align-items-center curpo ckqbb p-2 pl-3 mr-2"
              style="background: #ffebd2; border-radius: 12px"
            >
              <!-- <img class="mr-1" style="width: 28px;font-size: calc(9px + 0.4vw);font-weight: 500;" src="@/img/daohangl/pic_hssy_haorenbi@2x.png" alt="" /> -->
              <div class="">
                <!-- <div style="font-size: calc(8px + 0.4vw);">{{ $t('总发行好人币') }}</div> -->
                <div class="sjbxzt" style="font-size: calc(8px + 0.4vw)">
                  {{ $t("平台总发好人积分") }}
                </div>
                <div
                  class="sjbzt"
                  style="font-size: calc(8px + 0.4vw); font-weight: 700"
                >
                  {{
                    coin.good_coin
                      ? coin.good_coin
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0"
                  }}
                </div>
              </div>
            </div>
            <div
              @click="funs()"
              class="d-flex align-items-center p-2 pl-3 mr-2 curpo ckqbb"
              style="background: #fdddc9; border-radius: 12px"
            >
              <!-- <img class="mr-1" style="width: 28px;font-size: calc(9px + 0.4vw);font-weight: 500;" src="@/img/daohangl/pic_hssy_tanbi@2x.png" alt="" /> -->
              <div class="">
                <!-- <div style="font-size: calc(8px + 0.4vw);">{{ $t('总发行碳币') }}</div> -->
                <div class="sjbxzt" style="font-size: calc(8px + 0.4vw)">
                  {{ $t("平台总发碳积分") }}
                </div>

                <div
                  class="sjbzt"
                  style="font-size: calc(8px + 0.4vw); font-weight: 700"
                >
                  {{
                    coin.carbon_coin
                      ? coin.carbon_coin
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0"
                  }}
                </div>
              </div>
            </div>
            <!-- <div class="d-flex curpo mr-3 mixsz align-items-center" v-if="token" @click="nonetoken()">
              <img style="width: 28px;height: 28px;" class="mr-1" src="@/img/daohangl/icon_tcdl@2x.png" alt="" />
              <div class="" style="font-size: calc(9px + 0.4vw);">{{ $t('退出登录') }}</div>
            </div>
            <div class="dengluann pt-2 pb-2 mr-3 pl-3 pr-3" v-else @click="nonetoken()">
              <div class="" style="font-size: calc(9px + 0.4vw);">{{ $t('common.login') }}</div>
            </div> -->
          </div>
          <div
            v-show="beih"
            @click="yiny"
            style="
              width: 100%;
              height: 100%;
              background: #000;
              z-index: 999;
              position: absolute;
              opacity: 0.2;
            "
          ></div>
        </div>
      </div>
      <div
        class="d-flex col-md-12 pt-3 position-relative huise justify-content-between yunasn"
        style="border-radius: 12px 12px 0px 0px; overflow-y: auto"
      >
        <div class="index_one">
          <div
            class="col-md-4 col-sm-5 col-lg-3 col-xl-2 p-0 lieb pr-2"
            style="
              position: fixed;
              overflow: auto;
              height: calc(91vh - 1rem);
              display: flex;
              flex-direction: column;
              width: 20vw;
            "
          >
            <left :user="user"></left>
          </div>
          <div
            class="col-md-4 col-sm-5 col-lg-3 col-xl-2 p-0"
            style="visibility: hidden"
          >
            <left :user="user"></left>
          </div>
        </div>

        <!-- 手机端左侧显示尾 -->
        <div
          class="col-md-12 col-sm-12 col-lg-9 col-xl-10 pl-0 pr-0 wdd"
          style="display: flex; flex-direction: column"
          id="zhixingld"
        >
          <router-view style="flex: 0.7" />
          <div
            class="yuanjiao baise pt-3 pb-3 mb-3 index_one"
            :style="{
              position: 'relative',
              bottom: '0',
              'font-size': 'calc(8px + 0.4vw)',
              color: '#999999',
              width: hasRightSidebar ? 'calc( 100% - 21vw )' : '100%',
            }"
          >
            <!-- style="position:relative;bottom:0;;width: calc( 100% - 21vw );font-size: calc(8px + 0.4vw);color: #999999;" -->
            <div class="d-flex" style="flex-wrap: wrap">
              <div class="pl-3" style="width: 38%">
                <div class="d-flex align-items-center">
                  <img
                    class="mr-2"
                    style="width: 40px"
                    src="@/img/a43fcd05b8eea20d11d154c917aa55a.png"
                    alt=""
                  />
                  <div style="font-weight: 500; color: #1a1a1a">
                    {{ $t("孔雀魚數位科技股份有限公司") }}
                  </div>
                </div>
                <div class="mt-3">
                  <div>{{ $t("歡迎來到好事道，一個讓企業、個人ESG好事") }}</div>
                  <div>{{ $t("數據可信、透明、可流通、貨幣化的組織") }}</div>
                </div>
                <!-- <div class="mt-3">{{ $t('公司統編') }}：94105597</div> -->
                <div class="d-flex mt-3">
                  <div
                    class="mr-2"
                    v-if="datamk && datamk.img_one && datamk.img_one.url"
                  >
                    <img
                      style="width: 50px; height: 50px; object-fit: cover"
                      :src="datamk.img_one.url"
                      alt=""
                    />
                  </div>
                  <div
                    class="mr-2"
                    v-if="datamk && datamk.img_two && datamk.img_two.url"
                  >
                    <img
                      style="width: 50px; height: 50px; object-fit: cover"
                      :src="datamk.img_two.url"
                      alt=""
                    />
                  </div>
                  <div
                    class="mr-2"
                    v-if="datamk && datamk.img_three && datamk.img_three.url"
                  >
                    <img
                      style="width: 50px; height: 50px; object-fit: cover"
                      :src="datamk.img_three.url"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div style="width: 60%">
                <div style="width: 100%" class="footBox">
                  <div class="mb-3" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("常見問題") }}
                  </div>
                  <div class="mb-3 curpo" @click="fun('/about-us')">
                    {{ $t("关于我们") }}
                  </div>
                  <div class="mb-3 curpo" @click="fun('/directions')">
                    {{ $t("使用说明") }}
                  </div>
                  <div class="mb-3 curpo" @click="tiaozapi()">
                    {{ $t("API") }}
                  </div>
                </div>
                <div style="width: 100%" class="footBox">
                  <div class="mb-3" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("平台政策") }}
                  </div>
                  <div class="mb-3 curpo" @click="fun('/service-terms')">
                    {{ $t("服務條款") }}
                  </div>
                  <div class="mb-3 curpo" @click="fun('/privacy')">
                    {{ $t("隐私协议") }}
                  </div>
                  <div class="mb-3 curpo" @click="fun('/userPolicy')">
                    {{ $t("用户政策") }}
                  </div>
                </div>
                <div style="width: 100%" class="footBox">
                  <div class="mb-3" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("社群追蹤") }}
                  </div>
                  <div
                    v-for="(item, index) in datamk.list"
                    :key="index"
                    class="mb-3 curpo"
                    @click="tiaozapis(item.url)"
                  >
                    {{ item.title }}
                  </div>
                </div>
                <div style="width: 100%" class="footBox">
                  <div class="mb-3" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("聯繫我們") }}
                  </div>
                  <div class="mb-3">TEL: {{ datamk.tel }}</div>
                  <div class="mb-3">MAIL: {{ datamk.mail }}</div>
                  <div class="mb-3">公司統編: {{ datamk.tax }}</div>
                </div>
              </div>
            </div>
            <div
              class="mt-4"
              style="width: 100%; height: 1px; background: #e5e5e5"
            ></div>
            <div class="text-center mt-3">
              Copyright © 2025 | {{ $t("孔雀魚數位科技") }} Co., Ltd.
              {{ $t("保留所有權利") }}
            </div>
          </div>
          <div
            class="yuanjiao baise pt-3 pb-3 mb-3 sjiindex"
            style="width: 100%; font-size: calc(11px + 0.4vw); color: #999999"
          >
            <div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div class="d-flex align-items-center">
                  <img
                    class="mr-2"
                    style="width: 40px"
                    src="@/img/a43fcd05b8eea20d11d154c917aa55a.png"
                    alt=""
                  />
                  <div class="sjbzt" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("孔雀魚數位科技股份有限公司") }}
                  </div>
                </div>
              </div>
              <div class="pl-3 pr-3">
                <div class="mt-3">
                  <div class="text-center">
                    {{
                      $t(
                        "歡迎來到好事道，一個讓企業、個人ESG好事數據可信、透明、可流通、貨幣化的組織"
                      )
                    }}
                  </div>
                </div>
                <!-- <div class="mt-3 text-center">{{ $t('公司統編') }}：94105597</div> -->
              </div>
              <div class="d-flex mt-3 mb-3" style="justify-content: center">
                <div
                  class="mr-2"
                  v-if="datamk && datamk.img_one && datamk.img_one.url"
                >
                  <img
                    style="width: 50px; height: 50px; object-fit: cover"
                    :src="datamk.img_one.url"
                    alt=""
                  />
                </div>
                <div
                  class="mr-2"
                  v-if="datamk && datamk.img_two && datamk.img_two.url"
                >
                  <img
                    style="width: 50px; height: 50px; object-fit: cover"
                    :src="datamk.img_two.url"
                    alt=""
                  />
                </div>
                <div
                  class="mr-2"
                  v-if="datamk && datamk.img_three && datamk.img_three.url"
                >
                  <img
                    style="width: 50px; height: 50px; object-fit: cover"
                    :src="datamk.img_three.url"
                    alt=""
                  />
                </div>
              </div>
              <div class="d-flex text-center">
                <div style="width: 50%">
                  <div class="mb-2" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("常見問題") }}
                  </div>
                  <div class="mb-2 curpo" @click="fun('/about-us')">
                    {{ $t("关于我们") }}
                  </div>
                  <div class="mb-2 curpo" @click="fun('/directions')">
                    {{ $t("使用说明") }}
                  </div>
                  <div class="mb-2 curpo" @click="tiaozapi()">
                    {{ $t("API") }}
                  </div>
                </div>
                <div style="width: 50%">
                  <div class="mb-2" style="font-weight: 500; color: #1a1a1a">
                    {{ $t("平台政策") }}
                  </div>
                  <div class="mb-2 curpo" @click="fun('/service-terms')">
                    {{ $t("服務條款") }}
                  </div>
                  <div class="mb-2 curpo" @click="fun('/privacy')">
                    {{ $t("隐私协议") }}
                  </div>
                  <div class="mb-3 curpo" @click="fun('/userPolicy')">
                    {{ $t("用户政策") }}
                  </div>
                </div>
              </div>
              <div class="d-flex text-center">
                <div style="width: 50%">
                  <div
                    class="mb-2 mt-2"
                    style="font-weight: 500; color: #1a1a1a"
                  >
                    {{ $t("社群追蹤") }}
                  </div>
                  <div
                    v-for="(item, index) in datamk.list"
                    :key="index"
                    class="mb-2 curpo"
                    @click="tiaozapis(item.url)"
                  >
                    {{ item.title }}
                  </div>
                </div>
                <div style="width: 50%">
                  <div
                    class="mb-2 mt-2"
                    style="font-weight: 500; color: #1a1a1a"
                  >
                    {{ $t("聯繫我們-孔雀魚數位科技") }}
                  </div>
                  <div class="mb-2">TEL: {{ datamk.tel }}</div>
                  <div class="mb-2">MAIL: {{ datamk.mail }}</div>
                  <div class="mb-2">{{ $t("公司統編") }}: {{ datamk.tax }}</div>
                </div>
              </div>
            </div>
            <div
              class="mt-4"
              style="width: 100%; height: 1px; background: #e5e5e5"
            ></div>
            <div class="text-center mt-3" style="width: 80%; margin: auto">
              Copyright © 2025 | {{ $t("孔雀魚數位科技") }} Co., Ltd.
            </div>
            <div class="text-center" style="width: 80%; margin: auto">
              {{ $t("保留所有權利") }}
            </div>
          </div>
        </div>

        <div
          v-show="beih"
          @click="yiny"
          style="
            width: 96.3%;
            height: 100%;
            background: #000;
            z-index: 999;
            position: absolute;
            opacity: 0.2;
          "
        ></div>
      </div>
    </div>
    <transition name="slide">
      <div
        v-show="isBoxVisible"
        class="box yuanjiao p-3"
        style="width: 20rem; background: #ffe5e4; color: #555353; z-index: 1000"
      >
        <div
          class="mb-2"
          style="
            font-weight: 600;
            color: #0c0d0e;
            font-size: calc(14px + 0.4vw);
          "
        >
          {{ $t("溫馨提示：") }}
        </div>
        <div style="font-size: calc(11px + 0.4vw)">
          {{
            $t(
              "您即將離開企業頁面，如需參與可銷假的志工活動請務必選擇企業專屬頁面所認列的活動!"
            )
          }}
        </div>
        <div class="d-flex mt-3">
          <div
            @click="isBoxVisible = false"
            class="curpo pl-4 pr-4 pt-2 pb-2 yuanjiao"
            style="
              color: #000;
              background: #fab1ab;
              font-size: calc(11px + 0.4vw);
            "
          >
            {{ $t("我已知曉") }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { EventBus } from "@/views/event-bus.js";
import SkeletonScreen from "@/components/SkeletonScreen.vue";
import top from "@/components/top.vue";
import left from "@/components/left.vue";
import { about_api } from "@/request/api.js";
import { common_base, common_footer_config } from "@/request/api.js";
export default {
  watch: {
    // 监听路由对象中的path属性，它包含了当前的路由地址
    "$route.path": function (newPath, oldPath) {
      if (newPath == "/activity") {
        let c = localStorage.getItem("is_member");
        console.log(c, "12323234");
        if (c == 1) {
          this.isBoxVisible = true;
          localStorage.removeItem("is_member");
        } else {
          localStorage.removeItem("is_member");
        }
      }
      // 当二级路由发生变化时，这里的代码会被执行
      if (newPath.startsWith("/")) {
        // 这里处理二级路由变化的逻辑
        this.dingw();
      }
    },
    "$route.path": {
      handler(newPath) {
        this.$nextTick(() => {
          // 添加自动检测逻辑
          const sidebar = document.querySelector(".leftSidebarBox");
          // console.log('就收的2' , !!sidebar)
          this.hasRightSidebar =
            !!sidebar && window.getComputedStyle(sidebar).display !== "none";
        });
      },
      immediate: true,
    },
  },
  components: {
    top,
    SkeletonScreen,
    left,
  },
  data() {
    return {
      dataLoaded: false,
      token: localStorage.getItem("token"),
      message: "Hello from Component A",
      beih: false,
      route: "",
      isBoxVisible: false,
      datamk: {
        img_one: { url: "" }, // 添加預設結構，避免undefined錯誤
        img_two: { url: "" },
        img_three: { url: "" },
      },
      // 获取当前屏幕的宽度设置css样式
      screenWidth: window.innerWidth,
      show: true,
      // 主题颜色数组
      options: [
        {
          text: this.$t("common.darkTheme"),
          value: "dark",
        },
        {
          text: this.$t("common.lightTheme"),
          value: "light",
        },
        {
          text: this.$t("common.yellowTheme"),
          value: "yellow",
        },
      ],
      // 要切换的颜色背景色
      themes: {
        dark: {
          fontColor: "white",
          backgroundColor: "#000",
        },
        light: {
          fontColor: "#000",
          backgroundColor: "#fff",
        },
        yellow: {
          fontColor: "#000",
          backgroundColor: "yellow",
        },
        // 可以添加更多主题配置
      },
      userInfo: {}, // 用户信息
      coin: {}, // 代币信息
      user: {}, // 用户信息
      activity: {}, // 活动信息
      task: {}, // 任务信息
      hasRightSidebar: false, // 侧边栏状态
    };
  },
  created() {
    this.getUser();
    this.footer_config();
    // 组件创建时监听事件
    EventBus.$on("call-sibling-b-method", (msg) => {
      this.token = localStorage.getItem("token");
      // 执行方法，处理接收到的数据
      this.message = msg;
      // 如果需要，可以在这里调用其他方法
      this.getUser();
    });
    EventBus.$on("sidebar-status", (hasSidebar) => {
      // console.log('就收的1' , hasSidebar)
      this.hasRightSidebar = hasSidebar;
    });
  },
  beforeDestroy() {
    // 组件销毁前移除监听器，防止内存泄漏
    EventBus.$off("call-sibling-b-method");
  },
  mounted() {
    this.dingw();
    // 组件挂载后，设置默认主题
    // this.selectOption("light"); // 初始化主题
  },
  methods: {
    indexPath() {
      this.$router.push("/");
    },
    async footer_config() {
      const { data, code } = await common_footer_config();
      if (code == 200) {
        this.datamk = data;
      }
    },
    async tiaozapi() {
      const { data } = await about_api();
      window.location.href = data.data.url;
    },
    tiaozapis(e) {
      window.location.href = e;
    },
    dingw() {
      this.route = this.$route.path;
      if (this.$route.path == "/join") {
        this.route = "/activity";
      }
    },
    // 删除token地方退出登录
    nonetoken() {
      localStorage.removeItem("token");
      localStorage.removeItem("user_id");
      localStorage.setItem("previousRoutePath", this.$router.currentRoute);
      this.$router.push("/login");
    },
    // 获取基本信息
    getUser() {
      common_base({
        is_coin: 1,
        is_user: 1,
        is_activity: 1,
        is_task: 1,
      }).then((res) => {
        if (res.code == 200) {
          this.dataLoaded = true;
        }
        if (res.data.coin) {
          this.coin = res.data.coin; // 代币信息
        }
        if (res.data.user) {
          this.user = res.data.user; // 用户信息
          this.$store.commit("setUser", res.data.user);
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user_id");
          EventBus.$emit("token", "Hello ");
        }

        // this.activity = res.data.activity // 活动信息
        // this.task = res.data.task // 任务信息
        // console.log(res.data,'获取基本信息')
      });
    },
    toggleMenu() {
      this.beih = true;
      const sidebar = document.getElementById("sidebarMenu");
      sidebar.classList.toggle("collapse");
    },
    yiny() {
      this.beih = false;
      const sidebar = document.getElementById("sidebarMenu");
      sidebar.classList.toggle("collapse");
    },
    // 跳转登录
    fun(e) {
      if (this.$route.path == e) {
        return;
      } else {
        this.$router.push(e);
      }
      // if (v) {
      //   const element = document.getElementById(v);
      //   if (element) {
      //     element.scrollIntoView({ behavior: "smooth" });
      //   }
      // }
    },
    // 添加缺失的 funs 方法
    funs() {
      // 根據模板中的用途，這個方法可能是用於跳轉到個人中心
      if (this.token) {
        this.$router.push("/grzx");
      } else {
        this.$router.push("/login");
      }
    },
    // 切换背景颜色
    selectOption(e) {
      const theme = this.themes[e];
      document.documentElement.style.setProperty(
        "--font-color",
        theme.fontColor
      );
      document.documentElement.style.setProperty(
        "--background-color",
        theme.backgroundColor
      );
    },
    // 切换语言
    changeLang(lang) {
      localStorage.setItem("language", lang);
      switch (lang) {
        case "cht":
          this.$i18n.locale = lang;
          break;
        case "en":
          this.$i18n.locale = lang;
          break;
        case "cn":
          this.$i18n.locale = lang;
          break;
      }
      this.$router.go(0);
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  color: white;
  position: fixed;
  top: 6rem;
  right: 1rem;
  transform: translateX(0%); /* 初始状态在屏幕外 */
  transition: transform 0.5s ease, opacity 0.5s ease; /* 添加动画效果 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* 进入动画 */
.slide-enter-active {
  transition: transform 0.5s ease, opacity 0.5s ease; /* 平滑动画 */
}
.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}

/* 离开动画 */
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-leave-to {
  transform: translateX(90%);
  opacity: 0;
}
// @media screen and (max-width: 1068px) {
//   .sdsx {
//     display: block !important;
//   }
// }
@media screen and (max-width: 750px) {
  .sjleft {
    width: 60% !important;
  }
}
@media (max-width: 991px) {
  .sjbxzt {
    font-size: calc(9px + 0.4vw) !important;
  }
  .sjbzt {
    font-size: calc(10px + 0.4vw) !important;
  }
  .index_one {
    display: none;
  }
  .wdd {
    width: 100% !important;
  }
  .sjiindex {
    display: block !important;
  }
  .sjioashd {
    padding: 0 !important;
  }
  .yunasn {
    border-radius: 0 !important;
    padding-top: 0 !important;
  }
}
.footBox {
  display: flex;
}
.footBox div {
  width: 25%;
  text-align: left;
}
.dengluann {
  background: #ffd672;
  border-radius: 12px;
  text-align: center;
  font-size: calc(8px + 0.4vw);
  color: #1a1a1a;
  border: none;
}
.sjiindex {
  display: none;
}
.xptop {
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
}
.dengluann:active {
  opacity: 0.7;
  transform: scale(0.95); /* 点击时稍微缩放 */
}
/* 隐藏水平滚动条 */
.lieb::-webkit-scrollbar {
  display: none;
}
</style>

<style>
.leftSidebarBox {
  min-height: calc(90.5vh - 1rem) !important;
  max-height: calc(90.5vh - 1rem) !important;
  height: calc(90.5vh - 1rem) !important;
}
.leftSidebarBox > div:first-child {
  height: calc(90.5vh - 1rem) !important;
}
</style>
